import * as actions from './Actions.js';

import { Col, Row } from 'react-bootstrap';
import { Map, fromJS } from 'immutable';
import {
  PARAM_BUSCA_LICITACAO_ORDENADO_PROC_ADM,
  PARAM_USAWEBSERVICE_MARINGA
} from 'portaltransparencia-common/parametros/ParametrosPortalTransparencia';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';

import Component from 'react-pure-render/component';
import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import { Ellipsis } from 'portaltransparencia-common/components/Ellipsis.react.js';
import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import Fields from 'portaltransparencia-common/libs/Fields.js';
import FilterButtons from '../components/FilterButtons.react.js';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import ManualFornecedor from './ManualFornecedor.react';
import NotasExplicativas from '../notaexplicativa/Form.react';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import PageHeader from '../components/PageHeader.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import ParametroService from '../parametros/ParametroService.js';
import PropTypes from 'prop-types';
import React from 'react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import SumListField from 'portaltransparencia-common/components/SumListField.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import UltimaAtualizacao from '../ultimaatualizacao/Form.react.js';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';
import { changeFieldValue } from 'portaltransparencia-common/crud/Actions.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import { connect } from 'react-redux';
import { downloadArquivo } from '../arquivo/Actions';
import alert from 'sweetalert';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';

const selectIsRS = state => {
  const entidade = state.entidade.get('entidadeSelecionada');
  return !!(entidade && entidade.get('uf') === 'RS');
};
export class Licitacao extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    naturezas: PropTypes.object.isRequired,
    situacoes: PropTypes.object.isRequired,
    findLicitacoes: PropTypes.func.isRequired,
    modalidades: PropTypes.object,
    loadModalidades: PropTypes.func.isRequired,
    loadNaturezasProcedimento: PropTypes.func.isRequired,
    searchLicitacoes: PropTypes.func.isRequired,
    changeFieldValue: PropTypes.func.isRequired,
    exportaLicitacoes: PropTypes.func,
    filtros: PropTypes.object,
    onChange: PropTypes.func,
    location: PropTypes.object.isRequired,
    resetCrud: PropTypes.func.isRequired,
    downloadArquivo: PropTypes.func.isRequired,
    paramUsaWebService: PropTypes.string,
    paramOrdenaProcAdm: PropTypes.string,
    linksLicitacao: PropTypes.object,
    findLinksUteis: PropTypes.func.isRequired,
    addErrorNotification: PropTypes.func.isRequired,
    isIntegradoOxy: PropTypes.bool.isRequired,
    entidadeSelecionada: PropTypes.object,
    isRS: PropTypes.bool
  };

  componentDidMount() {
    const {
      loadModalidades,
      loadNaturezasProcedimento,
      findLinksUteis
    } = this.props;
    const { entidade } = StorageService.getItem('userInfo');

    findLinksUteis(entidade.id);
    loadModalidades();
    loadNaturezasProcedimento();
    this.onResetFiltro('filtroLicitacoes');
  }

  onChangeFiltro = event => {
    const { onChange } = this.props;

    onChange('filtroLicitacoes', event);
  };

  onResetFiltro = () => {
    const { resetCrud, searchLicitacoes } = this.props;
    const { exercicio } = StorageService.getItem('userInfo');
    resetCrud('filtroLicitacoes');

    let filtroExtra = '';

    if (!this.isAgendamento()) {
      this.onChangeFiltro({
        name: 'anoLicitacao',
        value: exercicio.id
      });
      filtroExtra += '&exercicio=' + exercicio.id;
    }

    searchLicitacoes(this.montaFilter() + filtroExtra);
  };

  isAgendamento = () => {
    const { location } = this.props;

    return (
      location &&
      location.pathname &&
      location.pathname.includes('agendamentos')
    );
  };

  get statusField() {
    return this.props.isRS ? 'evento' : 'situacao';
  }

  montaFilter = function (page) {
    const { entidade } = StorageService.getItem('userInfo');
    const { filtros, paramOrdenaProcAdm } = this.props;

    const isAgendamentoRoute = this.isAgendamento();

    let filter = `${isAgendamentoRoute ? '' : `entidade=${entidade.id}`}`;

    let ataDeAdesaoChecked = filtros.get('ataDeAdesao');

    if (isAgendamentoRoute) {
      const dataAtual = DateUtils.formatDate(new Date(), 'yy-mm-dd');

      filter = addFilterUrl(
        filter,
        `entidade=${entidade.id}&dataAberturaMaior=${dataAtual}`
      );

      if (filtros.get('ignoraEntidadeLogada')) {
        filter = addFilterUrl(
          filter,
          `ignoraEntidadeLogada=${filtros.get('ignoraEntidadeLogada')}`
        );
      }
    }

    if (this.refs.modalidade && this.refs.modalidade.getValue()) {
      filter = addFilterUrl(
        filter,
        'modalidade=' + this.refs.modalidade.getValue()
      );
    }
    if (this.refs.numeroLicitacao && this.refs.numeroLicitacao.getValue()) {
      filter = addFilterUrl(
        filter,
        'numeroLicitacao=' + this.refs.numeroLicitacao.getValue()
      );
    }
    if (filtros.get('anoLicitacao')) {
      filter = addFilterUrl(filter, `exercicio=${filtros.get('anoLicitacao')}`);
    }
    if (this.refs.numeroProcesso && this.refs.numeroProcesso.getValue()) {
      filter = addFilterUrl(
        filter,
        'numeroProcesso=' + this.refs.numeroProcesso.getValue()
      );
    }

    if (this.refs[this.statusField] && this.refs[this.statusField].getValue()) {
      if (this.refs[this.statusField].getValue() != -1) {
        filter = addFilterUrl(
          filter,
          `${this.statusField}=${this.refs[this.statusField].getValue()}`
        );
      }
    }
    if (this.refs.objeto && this.refs.objeto.getValue()) {
      filter = addFilterUrl(filter, 'objeto=' + this.refs.objeto.getValue());
    }
    if (
      filtros.get('dataAbertura') &&
      filtros.get('dataAbertura').length == 10
    ) {
      let validValue = DateUtils.transform(
        filtros.get('dataAbertura'),
        'yy-mm-dd',
        'yy-mm-dd'
      );
      filter = addFilterUrl(filter, `dataAbertura=${validValue}`);
    }
    if (filtros.get('natureza')) {
      filter = addFilterUrl(filter, `natureza=${filtros.get('natureza')}`);
    }
    if (this.refs.cnpjCpf && this.refs.cnpjCpf.getValue()) {
      filter = addFilterUrl(filter, 'cnpjCpf=' + this.refs.cnpjCpf.getValue());
    }
    if (filtros.get('ignoraExercicioLogado')) {
      filter = addFilterUrl(
        filter,
        `ignoraExercicioLogado=${filtros.get('ignoraExercicioLogado')}`
      );
    }

    filter = addFilterUrl(
      filter,
      `ataDeAdesao=${ataDeAdesaoChecked ? 'S' : 'N'}`
    );

    let pagination = addPagination(page, filter);
    if (paramOrdenaProcAdm === 'S' && !pagination.includes('sort=')) {
      pagination += '&sort=PA.EXERCICIO, PA.NUMERO,asc';
    }
    return pagination;
  };

  onConsultaLicitacoes = event => {
    if (
      !this.isAgendamento() &&
      !this.permiteIgnorarExercicio() &&
      !this.props.filtros?.get('anoLicitacao')
    ) {
      return alert('Informe algum filtro para poder realizar a pesquisa.');
    }

    const { page } = this.props;

    const initialPage = page.set('number', 0);

    this.searchWithPage(initialPage);

    event && event.preventDefault();
    this.refs.panelFiltroLicitacoes &&
      this.refs.panelFiltroLicitacoes.collapse();
  };

  searchWithPage = page => {
    const { searchLicitacoes } = this.props;

    let filter = this.montaFilter(page);

    searchLicitacoes(filter);
  };

  onChange = event => {
    const { changeFieldValue } = this.props;

    Fields.fireChange(changeFieldValue, event);

    this.onChangeFiltro(event);
  };

  renderLicitacoes = data => {
    const { isRS } = this.props;
    const key = `${data.get('entidade')}_${data.get('exercicio')}_${data.get(
      'tipoLicitacao'
    )}_${data.get('licitacao')}`;
    return (
      <TableActions
        ref="row"
        key={key}
        data={data}
        onMore={this.onViewDetalhes}
      >
        <td>{data.get('displayProcessoAdm')}</td>
        <td>{DateUtils.transform(data.get('dataAbertura'))}</td>
        <td>{data.get('descricao')}</td>
        <td style={{ 'word-break': 'break-word' }}>{data.get('natureza')}</td>
        <td>{data.get('displayLicitacao')}</td>
        {!isRS ? (
          <>
            <td>{data.get('tipoCancelamento')}</td>
            <td></td>
          </>
        ) : (
          <>
            <td></td>
            <td>
              {data.getIn(['tipoCancelamentoEvento', 'descricao']) ||
                data.getIn(['tipoCancelamentoEvento', 'value']) ||
                ''}
            </td>
          </>
        )}
        <td className="right">
          {data.get('orcamentoSigiloso') !== 'S' &&
            NumberUtils.format(data.get('valorMaximo'), 'R$ 0,0.00')}
        </td>
        <td className="right">
          {NumberUtils.format(data.get('totalVencido'), 'R$ 0,0.00')}
        </td>
        <td title={data.get('objeto')}>
          {<Ellipsis value={data.get('objeto')} maxLength={250} />}
        </td>
      </TableActions>
    );
  };

  renderSituacao = item => {
    const isMap = Map.isMap(item);
    const value = isMap ? item.get('value') : item;
    const label = isMap ? item.get('label') : item;
    return (
      <option key={value} value={value}>
        {label}
      </option>
    );
  };

  onViewDetalhes = item => {
    const { history } = this.props;
    const entidade = item.get('entidade');
    const exercicio = item.get('exercicio');
    const tipoLicitacao = item.get('tipoLicitacao');
    const licitacao = item.get('licitacao');

    return history.push(
      `${
        this.isAgendamento() ? '/licitacoes-agendamentos' : '/licitacoes'
      }/detalhes?entidade=${entidade}&exercicio=${exercicio}&tipoLicitacao=${tipoLicitacao}&licitacao=${licitacao}`
    );
  };

  onExporta = (exportType, openTab, windowParams) => {
    const { page, addErrorNotification } = this.props;
    const { apiURL } = configuration;

    if (page.get('content').size > 0) {
      let filtro = this.montaFilter(page) + '&exportType=' + exportType;

      window.open(
        `${apiURL}/api/licitacoes/report?${filtro}`,
        openTab,
        windowParams
      );
    } else {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
    }
  };

  renderModalidades = data => {
    return (
      <option key={data.get('id')} value={data.get('id')}>
        {data.get('id') + ' - ' + data.get('descricao')}
      </option>
    );
  };

  renderNaturezas = () => {
    const { filtros, naturezas } = this.props;
    const naturezasPorModalidade = naturezas?.filter(
      n => n.get('tipoLicitacao') == filtros.get('modalidade')
    );

    return (
      naturezasPorModalidade &&
      naturezasPorModalidade.map(data => (
        <option
          key={`${data.get('tipoLicitacao')}_${data.get(
            'naturezaProcedimentoDescricao'
          )}_${data.get('naturezaProcedimento')}`}
          value={data.get('naturezaProcedimentoDescricao')}
        >
          {data.get('naturezaProcedimentoDescricao')}
        </option>
      ))
    );
  };

  openSala = link => {
    window.open(link, '_blank', 'width=800, height=600');
  };

  renderPlaceholderNatureza = () => {
    const { filtros } = this.props;

    return (
      <option value="">
        {filtros && filtros.get('modalidade')
          ? 'Selecione'
          : 'Selecione uma modalidade'}
      </option>
    );
  };

  permiteIgnorarExercicio = () => {
    const { filtros } = this.props;
    return (
      filtros.get('modalidade') ||
      filtros.get('natureza') ||
      filtros.get('numeroProcesso') ||
      filtros.get('numeroLicitacao') ||
      filtros.get('cnpjCpf') ||
      filtros.get('dataAbertura') ||
      filtros.get(this.statusField) ||
      filtros.get('objeto')
    );
  };

  render() {
    const {
      page,
      situacoes,
      modalidades,
      filtros,
      linksLicitacao,
      isIntegradoOxy,
      isRS
    } = this.props;

    const isAgendamentoRoute = this.isAgendamento();

    if (!page.has('content')) {
      return null;
    }

    return (
      <section>
        <PageHeader location={this.props.location} />

        {linksLicitacao.length > 0 && (
          <div id="salas" className="align-group center mb-xs">
            <button className="inline mr-xs">
              Licitação On-line
              <em className="ml-xs fa fa-long-arrow-right" />
            </button>
            {linksLicitacao.map((link, i) => {
              const onClick = () => this.openSala(link.get('link'));
              return (
                <button
                  key={i}
                  id={`sala${i + 1}`}
                  className="btn neutral inline"
                  onClick={onClick}
                  title={link.descricao}
                >
                  {`Sala ${i + 1}`}
                </button>
              );
            })}
          </div>
        )}

        <NotasExplicativas pathname={this.props.location.pathname} />

        <Panel
          title="Consultar em Licitações"
          isForm
          mobileClose
          ref="panelFiltroLicitacoes"
        >
          <form>
            <Row>
              <Col xs={12} sm={4} md={3}>
                <Input
                  id="modalidade"
                  name="modalidade"
                  ref="modalidade"
                  label="Modalidade"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('modalidade')}
                >
                  <option value="">Selecione</option>
                  {modalidades && modalidades.map(this.renderModalidades)}
                </Input>
              </Col>
              <Col xs={12} sm={4} md={3}>
                <Input
                  id="natureza"
                  name="natureza"
                  ref="natureza"
                  label="Natureza"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('natureza')}
                  disabled={!filtros.get('modalidade')}
                >
                  {this.renderPlaceholderNatureza()}
                  {this.renderNaturezas()}
                </Input>
              </Col>
              <Col xs={5} sm={3} md={2}>
                <Input
                  id="numeroLicitacao"
                  name="numeroLicitacao"
                  ref="numeroLicitacao"
                  placeholder="Nº da Licitação"
                  label="Nº da Licitação"
                  type="number"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('numeroLicitacao')}
                />
              </Col>
              <Col xs={5} sm={3} md={2}>
                <Input
                  id="anoLicitacao"
                  name="anoLicitacao"
                  ref="anoLicitacao"
                  placeholder="Ano Licitação"
                  label="Ano Licitação"
                  type="number"
                  disabled={filtros.get('ignoraExercicioLogado')}
                  onChange={this.onChangeFiltro}
                  value={filtros.get('anoLicitacao')}
                />
              </Col>
              <Col xs={5} sm={3} md={2}>
                <Input
                  id="numeroProcesso"
                  name="numeroProcesso"
                  ref="numeroProcesso"
                  placeholder="Nº da Processo"
                  label="Nº do Processo"
                  type="number"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('numeroProcesso')}
                />
              </Col>
              <Col xs={12} sm={12} md={3}>
                <Input
                  id={this.statusField}
                  name={this.statusField}
                  ref={this.statusField}
                  label="Situação"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get(this.statusField)}
                >
                  <option value="-1">Selecione</option>
                  {situacoes.map(this.renderSituacao)}
                </Input>
              </Col>
              <Col xs={6} sm={2} md={2}>
                <DatePicker
                  id="dataAbertura"
                  name="dataAbertura"
                  ref="dataAbertura"
                  label="Data Abertura"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('dataAbertura')}
                />
              </Col>
              {!isAgendamentoRoute && (
                <Col xs={6} sm={4} md={2}>
                  <Input
                    id="cnpjCpf"
                    type="text"
                    ref="cnpjCpf"
                    name="cnpjCpf"
                    label="CNPJ/CPF Participante"
                    onChange={this.onChangeFiltro}
                    value={filtros.get('cnpjCpf')}
                  />
                </Col>
              )}
              <Col xs={6} sm={4} md={3}>
                <div className="form-group">
                  <label
                    className="label"
                    placeholder="Preencha algum filtro para habilitar"
                  ></label>
                  <Input
                    id="ignoraExercicioLogado"
                    label="Ignora Exercício Logado"
                    type="checkbox"
                    ref="ignoraExercicioLogado"
                    name="ignoraExercicioLogado"
                    onChange={this.onChangeFiltro}
                    checked={filtros.get('ignoraExercicioLogado')}
                    disabled={!this.permiteIgnorarExercicio()}
                    placeholder="Preencha algum filtro para habilitar"
                  />
                </div>
              </Col>
              <Col xs={6} sm={2} md={2}>
                <div className="form-group">
                  <label
                    className="label"
                    placeholder="Preencha algum filtro para habilitar"
                  ></label>
                  <Input
                    id="ataDeAdesao"
                    label="Ata de Adesão/Carona"
                    type="checkbox"
                    ref="ataDeAdesao"
                    name="ataDeAdesao"
                    onChange={this.onChangeFiltro}
                    checked={filtros.get('ataDeAdesao')}
                  />
                </div>
              </Col>
              {isAgendamentoRoute && (
                <Col xs={12} sm={4} md={3}>
                  <div className="form-group">
                    <label className="label"></label>
                    <Input
                      id="ignoraEntidadeLogada"
                      label="Ignora Entidade Logada"
                      type="checkbox"
                      ref="ignoraEntidadeLogada"
                      name="ignoraEntidadeLogada"
                      onChange={this.onChangeFiltro}
                      checked={filtros.get('ignoraEntidadeLogada')}
                    />
                  </div>
                </Col>
              )}
              <Col xs={12} sm={12} md={12}>
                <Input
                  id="objeto"
                  type="text"
                  ref="objeto"
                  name="objeto"
                  placeholder="Objeto"
                  label="Objeto"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('objeto')}
                />
              </Col>
              <Col xs={12} sm={4} md={3}>
                <FilterButtons
                  idBtnReset="btnResetFilter"
                  onConsulta={this.onConsultaLicitacoes}
                  onReset={this.onResetFiltro}
                />
              </Col>
            </Row>
          </form>
        </Panel>

        <Panel isForm tableResponsive>
          <Row>
            <Col xs={4}>
              <UltimaAtualizacao modulo="10" tipo="licitacao" />
            </Col>
            <Col xs={5}>
              <ManualFornecedor />
            </Col>
            <Col xs={3}>
              <ExportButtonGroup onClick={this.onExporta} visible={true} />
            </Col>
          </Row>

          <div className="panel-table-outer">
            <table className="panel-table striped fancy">
              <TableHeader
                text="A entidade não possui editais em aberto no momento."
                empty={page.get('content').isEmpty()}
              >
                <tr>
                  <TableHeaderItem
                    field={
                      isIntegradoOxy
                        ? 'PA.EXERCICIO, PA.NUMERO'
                        : 'numeroProcessoAdm'
                    }
                    label="Processo Administrativo"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="dataAbertura"
                    label="Abertura"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="descricao"
                    label="Modalidade"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="natureza"
                    label="Natureza"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="numeroLicitacao"
                    label="Número"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  {!isRS ? (
                    <>
                      <TableHeaderItem
                        field="tipoCancelamento"
                        label="Situação"
                        page={page}
                        searchWithPage={this.searchWithPage}
                      />
                      <th></th>
                    </>
                  ) : (
                    <>
                      <th></th>
                      <TableHeaderItem
                        field="tipoCancelamentoEvento"
                        label="Situação"
                        page={page}
                        searchWithPage={this.searchWithPage}
                      />
                    </>
                  )}
                  <TableHeaderItem
                    field="valorMaximo"
                    label="Valor Máximo Processo"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <TableHeaderItem
                    field="totalVencido"
                    label="Valor Homologado"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <TableHeaderItem
                    field="objeto"
                    label="Objeto"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <th></th>
                </tr>
              </TableHeader>
              <tbody>{page.get('content').map(this.renderLicitacoes)}</tbody>
              {page.get('content').size > 0 && (
                <tfoot>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{ display: 'flex', textWrap: 'nowrap' }}>
                      <i>Total: </i>
                      <SumListField
                        fieldName="valorMaximo"
                        list={page.get('content')}
                      />
                    </td>
                    <td className="right">
                      <i>Total: </i>
                      <SumListField
                        fieldName="totalVencido"
                        list={page.get('content')}
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </Panel>

        <SearchPagination page={page} searchWithPage={this.searchWithPage} />
      </section>
    );
  }
}

function mapStateToProps(state) {
  const situacoesDefault = fromJS([
    'Adjudicada',
    'Aguardando Abertura',
    'Anulada',
    'Descartada',
    'Deserta',
    'Andamento',
    'Fracassada',
    'Homologada',
    'Revogada',
    'Suspensa pelo TCE',
    'Suspensa'
  ]);

  const situacoesRS = fromJS([
    { value: 'AED', label: 'Alteração do edital' },
    { value: 'AND', label: 'Anulação por determinação judicial' },
    { value: 'ANO', label: 'Anulação de ofício' },
    {
      value: 'EFC',
      label: 'Encerramento por falta de propostas classificadas'
    },
    { value: 'EFH', label: 'Encerramento por falta de licitantes habilitados' },
    { value: 'EFI', label: 'Encerramento por falta de interessados' },
    { value: 'ENC', label: 'Encerramento' },
    { value: 'ESC', label: 'Esclarecimento' },
    { value: 'IME', label: 'Impugnação do edital' },
    { value: 'PUB', label: 'Publicação' },
    { value: 'PUE', label: 'Publicação do Edital' },
    { value: 'RCL', label: 'Recurso de credenciamento/lances' },
    { value: 'REE', label: 'Republicação do edital' },
    { value: 'REI', label: 'Reinício' },
    { value: 'REO', label: 'Revogação de ofício' },
    { value: 'RHA', label: 'Recurso da habilitação' },
    { value: 'RHP', label: 'Recurso de habilitação/proposta' },
    { value: 'RPP', label: 'Recurso da proposta/objeto' },
    { value: 'RPR', label: 'Recurso da proposta' },
    { value: 'SDJ', label: 'Suspensão por determinação judicial' },
    { value: 'SUM', label: 'Suspensão por medida cautelar' },
    { value: 'SUO', label: 'Suspensão de ofício' },
    { value: 'HML', label: 'Homologação' }
  ]);
  const isRS = selectIsRS(state);
  return {
    page: state.licitacao.get('licitacoes'),
    naturezas: state.licitacao.get('naturezasProcedimento'),
    situacoes: isRS ? situacoesRS : situacoesDefault,
    modalidades: state.licitacao.get('modalidades'),
    filtros: state.crud.getIn(['filtroLicitacoes', 'currentRecord'], Map({})),
    entidadeSelecionada: state.entidade.get('entidadeSelecionada'),
    paramUsaWebService: ParametroService.getValorParametro(
      state,
      PARAM_USAWEBSERVICE_MARINGA
    ),
    paramOrdenaProcAdm: ParametroService.getValorParametro(
      state,
      PARAM_BUSCA_LICITACAO_ORDENADO_PROC_ADM
    ),
    linksLicitacao: state.licitacao.get('linksLicitacao'),
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ]),
    isRS
  };
}

const allActions = {
  ...actions,
  changeFieldValue,
  onChange,
  resetCrud,
  downloadArquivo,
  addErrorNotification
};

export default connect(mapStateToProps, allActions)(Licitacao);
